import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { getPublicCompany } from "@/lib/marketplace.functions";
import { TwinChat } from "@/components/TwinChat";

export const Route = createFileRoute("/embed/$companyId")({
  ssr: false,
  head: () => ({
    meta: [
      { title: "Twin Chat" },
      { name: "robots", content: "noindex,nofollow" },
      { name: "viewport", content: "width=device-width,initial-scale=1,viewport-fit=cover" },
    ],
  }),
  component: EmbedChat,
});

function EmbedChat() {
  const { companyId } = Route.useParams();
  const [company, setCompany] = useState<any>(null);
  const [err, setErr] = useState<string | null>(null);
  const [conversationId] = useState(() => crypto.randomUUID());

  useEffect(() => {
    getPublicCompany({ data: { id: companyId } })
      .then((r) => setCompany(r.company))
      .catch((e) => setErr(e?.message ?? "Twin not available"));
  }, [companyId]);

  if (err) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground text-sm p-6 text-center">
        {err}
      </div>
    );
  }
  if (!company) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground text-sm">
        Loading…
      </div>
    );
  }

  const initial = (company.name?.[0] ?? "?").toUpperCase();

  return (
    <div className="h-screen flex flex-col bg-background text-foreground">
      <header className="flex items-center gap-3 px-4 py-3 border-b border-border shrink-0">
        <div className="h-9 w-9 overflow-hidden rounded-full brand-gradient flex items-center justify-center text-black font-display font-bold">
          {company.logo_url ? (
            <img src={company.logo_url} alt={`${company.name} logo`} className="h-full w-full object-cover" />
          ) : (
            initial
          )}
        </div>
        <div className="min-w-0 flex-1">
          <div className="font-display font-semibold text-sm truncate">{company.name}</div>
          <div className="text-[11px] text-[oklch(0.82_0.18_168)] flex items-center gap-1.5">
            <span className="h-1.5 w-1.5 rounded-full bg-[oklch(0.82_0.18_168)] animate-pulse" />
            AI Twin online
          </div>
        </div>
      </header>

      <div className="flex-1 min-h-0">
        <TwinChat
          companyId={company.id}
          companyName={company.name}
          mode="visitor"
          conversationId={conversationId}
          placeholder={`Message ${company.name}…`}
        />
      </div>

      <div className="px-3 py-1.5 text-[10px] text-center text-muted-foreground shrink-0">
        Powered by{" "}
        <a href="https://realitytwin.io" target="_blank" rel="noopener" className="underline">
          Reality Twin
        </a>
      </div>
    </div>
  );
}
